import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslocoPipe } from '@jsverse/transloco';
import { map } from 'rxjs/operators';
import { CodingSystemsHttpService } from 'shared/domain';
import { UtcToLocalPipe, WrapFnPipe } from 'shared/util-common';

import { ActionType, CodingSystemDto, CodingValue, FlowchartElementType, GuidelineChapterType } from '@treetop/shared/model';

import { KeyValueComponent } from '../key-value/shared-ui-key-value.component';

@Component({
  selector: 'app-basic-info-components',
  templateUrl: './basic-info-components.component.html',
  styleUrls: ['./basic-info-components.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [KeyValueComponent, TranslocoPipe, UtcToLocalPipe, WrapFnPipe],
})
export class BasicInfoComponentsComponent {
  private codingSystemService = inject(CodingSystemsHttpService);

  protected codingSystemsMap = toSignal(
    this.codingSystemService.get().pipe(
      map((codingSystems) => {
        const codingSystemsMap = new Map<string, CodingSystemDto>();
        codingSystems.forEach((codingSystem) => codingSystemsMap.set(codingSystem.id, codingSystem));
        return codingSystemsMap;
      }),
    ),
  );

  @Input() public editor: string;
  @Input() public reviewer: string;
  @Input() public author: string;
  @Input() public publisher: string;
  @Input() public version: string;
  @Input() public code?: string;
  @Input() public createdAt: string;
  @Input() public updatedAt: string;
  @Input() public approvedDate: string;
  @Input() public publishDate: string;
  @Input() public actionType: string;
  @Input() public treetopCode: string;
  @Input() public isProposed?: boolean;
  @Input() public proposedInFlowchartElementType?: string;
  @Input() public proposingOrganisationId?: string;
  @Input() public proposedInGuidelineChapterType?: string;
  @Input() public codings?: CodingValue[];

  protected getKeyFromType(
    type: FlowchartElementType | GuidelineChapterType,
    enumForType: GuidelineChapterType | ActionType,
  ): string | undefined {
    const reverseMapping: { [key: number]: string } = {};

    if (Object.keys(reverseMapping).length === 0) {
      Object.entries(enumForType).forEach(([key, value]) => {
        reverseMapping[value as number] = key;
      });
    }

    return reverseMapping[type];
  }

  protected FlowchartElementType = FlowchartElementType;
  protected GuidelineChapterType = GuidelineChapterType;
  protected ActionType = ActionType;
}
